import React, { useContext, useState, useEffect } from 'react'
import { store, actions } from '../../stores/multipost'
import { Card, CardBody, CardHeader, Col, Input, Label, ListGroup, ListGroupItem, Row } from 'reactstrap'
import SocialAccountProvider from './socialAccountProvider'
import { ChevronRight, ChevronDown } from 'react-feather'

const MOBILE_BREAKPOINT = 768

export default function AccountSettings() {
  const { facebookAccounts, twitterAccounts, instagramAccounts, dispatch, selectedAccounts, selectedFiles, messages } = useContext(store)
  // For now ensure only one of each account type is usable
  const usableAccounts = [facebookAccounts[0], twitterAccounts[0], instagramAccounts[0]].filter(account => account);

  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    const checkWidth = () => {
      if (window.innerWidth >= MOBILE_BREAKPOINT) {
        setExpanded(true)
      } else {
        setExpanded(false)
      }
    }

    checkWidth()
    window.addEventListener('resize', checkWidth)

    return () => window.removeEventListener('resize', checkWidth)
  }, [])

  const inputName = (account) => {
    const provider = account.attributes.provider
    const hasEnabledActions = selectedFiles.some(file => file.assets.some(asset => asset.enabledActions.some(action => action.provider === provider)))
    const hasMessages = messages.default.value.length > 0 || messages[provider]?.value.length > 0

    if(hasEnabledActions || hasMessages){
      return `team_post[accounts][${provider}][post_to]`
    } else {
      return ''
    }
  }

  const inputId = (account) => {
    return `${account.attributes.provider}-${account.id}`
  }

  const toggleAccount = (account) => {
    if(selectedAccounts.includes(account)) {
      dispatch({
        type: actions.SET_ACCOUNTS,
        accounts: selectedAccounts.filter(a => a !== account),
      })
    } else {
      dispatch({
        type: actions.SET_ACCOUNTS,
        accounts: [...selectedAccounts, account],
      })
    }
  }

  function ExpandIcon() {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      return (
        React.createElement(
          expanded ? ChevronDown : ChevronRight,
          { size: 16, color: "#868686", className: "me-1" }
        )
      )
    }
  }

  return (
    <Card className="rounded-2 mb-4">
      <CardHeader className={`rounded-top-2 cursor-pointer ${!expanded && "border-bottom-0"}`} onClick={() => setExpanded(!expanded)}>
        <ExpandIcon />
        {selectedAccounts.length} {selectedAccounts.length === 1 ? "Account" : "Accounts"} Selected
      </CardHeader>
      <CardBody className="p-0" style={{ display: expanded ? "block" : "none" }}>
        <ListGroup flush={true} className="rounded-bottom-2">
          {usableAccounts.map((account, index) => {
            return (
              <ListGroupItem key={index}>
                <Row className="align-items-center">
                  <Col xs="auto" className="pe-0">
                    <Input type="checkbox" name={inputName(account)} id={inputId(account)} value={account.id} defaultChecked={selectedAccounts.includes(account.attributes.provider)} className="input-row-checkbox" onChange={(e) => toggleAccount(account.attributes.provider)} />
                  </Col>
                  <Col xs="auto" className="pe-0">
                    {React.createElement(SocialAccountProvider.find(account.attributes.provider).icon, { className: "icon icon-valign" })}
                  </Col>
                  {account.attributes.avatar && (
                  <Col xs="auto" className="pe-0">
                    <Label htmlFor={inputId(account)} className="m-0"><img src={account.attributes.avatar} className="avatar avatar-sm avatar-valign" alt={account.attributes.name} /></Label>
                  </Col>
                  )}
                  <Col>
                    <Label htmlFor={inputId(account)} className="m-0"><strong>{account.attributes.name}</strong></Label>
                  </Col>
                </Row>
              </ListGroupItem>
            )
          })}
        </ListGroup>
      </CardBody>
    </Card>
  )
}
